import clsx from "clsx";
import React, { useEffect, useState } from "react";

import RatingStar from "../../../molecules/RatingStar";
import { ITeacherLessonRetrospectives } from "../../../state";

import styles from "./EvaluationLessonModal.module.scss";

export type EvaluationLessonModalProps = {
  teacherLessonRetrospectives: ITeacherLessonRetrospectives | null;
  onRatingCompleted: (
    score: number,
    lessonDeliveryScore: number,
    groupWorkScore: number | null,
  ) => void;
  onClose: () => void;
};

const EvaluationLessonModal: React.FC<EvaluationLessonModalProps> = ({
  teacherLessonRetrospectives,
  onRatingCompleted,
  onClose,
}) => {
  const [selectedScore, setSelectedScore] = useState<number>(0);
  const [
    selectedLessonDeliveryScore,
    setSelectedLessonDeliveryScore,
  ] = useState<number>(0);
  const [selectedGroupWorkScore, setSelectedGroupWorkScore] = useState<number>(
    0,
  );

  useEffect(() => {
    if (!teacherLessonRetrospectives) return;
    setSelectedScore(teacherLessonRetrospectives.score);
    setSelectedLessonDeliveryScore(
      teacherLessonRetrospectives.lesson_delivery_score,
    );
    if (teacherLessonRetrospectives.group_work_score)
      setSelectedGroupWorkScore(teacherLessonRetrospectives.group_work_score);
  }, [teacherLessonRetrospectives]);

  const isRated = selectedScore > 0 && selectedLessonDeliveryScore > 0;

  return (
    <div className={styles.evaluationLesson}>
      <div className={styles.evaluationLesson__backDrop} onClick={onClose} />
      <div className={styles.evaluationLesson__content}>
        <p className={styles.title}>お疲れさまでした。</p>
        <div className={clsx(styles.description, "text-center")}>
          <strong>
            今回の授業を振り返りましょう。
            <br />
            アンケートの回答や、生徒の回答データは授業毎データで確認できます。
          </strong>
        </div>
        <div className="row mt-3">
          <div className="col-5" />
          <div className="col-7">
            <div className={styles.labels}>
              <span>できなかった</span>
              <span>できた</span>
            </div>
          </div>
        </div>
        <RatingStar
          indexTitle="1"
          title={<>授業に満足できましたか？</>}
          scoreNum={5}
          selectedScore={selectedScore}
          onRating={index => setSelectedScore(index)}
        />
        <RatingStar
          indexTitle="2"
          title={<>授業の内容をうまく伝えられましたか？</>}
          scoreNum={5}
          selectedScore={selectedLessonDeliveryScore}
          onRating={index => setSelectedLessonDeliveryScore(index)}
        />
        <RatingStar
          indexTitle="3"
          title={
            <>
              活発なグループワークができましたか？
              <br />
              <span className={styles.note}>※実施していない場合は空欄</span>
            </>
          }
          scoreNum={5}
          selectedScore={selectedGroupWorkScore}
          onRating={index => setSelectedGroupWorkScore(index)}
        />
        <div className="mt-4 d-flex justify-content-end">
          <button
            className={styles.btnSubmit}
            type="button"
            disabled={!isRated}
            onClick={() =>
              onRatingCompleted(
                selectedScore,
                selectedLessonDeliveryScore,
                selectedGroupWorkScore === 0 ? null : selectedGroupWorkScore,
              )
            }
          >
            完了して授業毎データへ
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluationLessonModal;
